import Storage from '@services/cache/IndexedDBStorage';

export const storage = new Storage({ name: 'shelvesSuggestions' });

function getSuggestions(key) {
  return storage.get(key);
}

export default getSuggestions;
